export var controlReset = "\n  font-family: inherit;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n";
